module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-md-c25fb55d1e1735d580b3b7887d08228b.png";